var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-3 d-flex",staticStyle:{"width":"100%"},attrs:{"id":"init-help-container"}},[_c('v-spacer'),_c('v-main',[_c('div',{staticStyle:{"max-width":"768px"},attrs:{"id":"help-container"}},[_c('h1',[_vm._v("Pending")])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }